import { IAuthorization } from "src/interfaces/auth";

export default (accessToken: string): IAuthorization => ({
  Authorization: `Bearer ${accessToken}`,
});
